export const domain = "https://2.gqjys.co";